var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33351 7C9.33351 8.28866 8.28884 9.33333 7.00017 9.33333C5.71151 9.33333 4.66684 8.28866 4.66684 7C4.66684 5.71134 5.71151 4.66667 7.00017 4.66667C8.28884 4.66667 9.33351 5.71134 9.33351 7ZM8.16684 7C8.16684 7.64433 7.64451 8.16667 7.00017 8.16667C6.35584 8.16667 5.83351 7.64433 5.83351 7C5.83351 6.35567 6.35584 5.83333 7.00017 5.83333C7.64451 5.83333 8.16684 6.35567 8.16684 7Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00017 1.75C10.2619 1.75 13.0026 3.98085 13.7796 7C13.0026 10.0191 10.2619 12.25 7.00017 12.25C3.73845 12.25 0.997778 10.0191 0.220703 7C0.997778 3.98085 3.73845 1.75 7.00017 1.75ZM7.00017 11.0833C4.38943 11.0833 2.17677 9.36725 1.43356 7C2.17677 4.63275 4.38943 2.91667 7.00017 2.91667C9.61092 2.91667 11.8236 4.63275 12.5668 7C11.8236 9.36725 9.61092 11.0833 7.00017 11.0833Z",
    fill: "#757575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewView);
export default __webpack_public_path__ + "static/media/new_view.8171faef1da7fb5a2e94ca2f84f5b3e1.svg";
export { ForwardRef as ReactComponent };